// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8064) return "static/chunks/8064-47dad4c00b8cf9d0.js";
	if (chunkId === 1945) return "static/chunks/1945-50c177478e15743b.js";
	if (chunkId === 9701) return "static/chunks/9701-caa1ee1ccfacc323.js";
	if (chunkId === 423) return "static/chunks/423-509014cbc41ec306.js";
	if (chunkId === 9814) return "static/chunks/9814-3ea19bb207840e51.js";
	if (chunkId === 5007) return "static/chunks/5007-15cb2530aab59e17.js";
	if (chunkId === 7457) return "static/chunks/7457-ba247e8bb9246661.js";
	if (chunkId === 3467) return "static/chunks/3467-a7d25f7fdfe649b6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"532":"731ce90c9c28eb9c","3447":"2bac82d7f7b60abd","4081":"a6cf542859947182","5183":"1537fabc840f38f4","7649":"34ba7fb7ffd2e0cc","8588":"d036a798d06a9e66","8814":"39117415418b33cd","9464":"195fa1551de28bcc"}[chunkId] + ".js";
};